import produce from 'immer';

import * as productReviewTypes from '@redux/actions/productReview/productReviewTypes';

const initState = {
  isLoading: false,
  productReviews: null,
};

const getProductReviewReducer = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case productReviewTypes.GET_PRODUCT_REVIEW:
      draft.isLoading = true;
      break;

    case productReviewTypes.GET_PRODUCT_REVIEW_SUCCESS:
      draft.isLoading = false;

      draft.productReviews = action.payload.ProductReviews;
      break;

    case productReviewTypes.GET_PRODUCT_REVIEW_FAILED:
      draft.isLoading = false;
      break;
    }

    return draft;
  });

export default getProductReviewReducer;